export function GetUuid() {
    let withLine = true //带不带横线
    let len = 36 //长度为36
    let radix = 16 //16进制
    let chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('')
    let uuid: Array<string> = [],
      i
    radix = radix || chars.length
    if (withLine) {
      let r
      uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-'
      uuid[14] = '4'
      for (i = 0; i < len; i++) {
        if (!uuid[i]) {
          r = 0 | (Math.random() * 16)
          uuid[i] = chars[i == 19 ? (r & 0x3) | 0x8 : r]
        }
      }
    } else {
      for (i = 0; i < len; i++) {
        uuid[i] = chars[0 | (Math.random() * radix)]
      }
    }
    return uuid.join('')
  }
  